import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import qpr from '../../assets/image/it_strategic/qpr.png'
import it_strategic2 from '../../assets/image/it_strategic/it_stategic2.png'
import it_strategic3 from '../../assets/image/it_strategic/it_strategic3.png'
import it_strategic4 from '../../assets/image/it_strategic/it_strategic4.png'
import it_strategic5 from '../../assets/image/it_strategic/it_strategic5.png'
import it_strategic6 from '../../assets/image/it_strategic/it_strategic6.png'
import altius from '../../assets/image/it_strategic/altius.png'

import it from '../../assets/image/strategy-organization/it.jpg'
export default class it_strategic extends Component {
    render() {
        const image=[
            {image:it}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Strategy and Organization','IT Strategic Solution']} image={image} title="IT Strategic  Solution" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                <b>PRODUCT SERVICES:</b>
                                <br/><br/>
                                <img src={qpr} style={{width:'50%'}}/>
                                <br/><br/>
                                <b>Performance Management System based on QPR Metrics Software and Process Designer</b>
                                QPR Metrics Software and Process Designer helps your organization overcome the complexities involved with implementing organization-wide performance management and provides a comprehensive process modelling and analysis environment. Flexibility, ease of use and powerful process modelling capabilities make QPR an ideal choice for organizations that seek to involve business professionals in reducing cost and cycle times, and improving productivity, risk awareness, quality and regulatory compliance.
                                <br/><br/>
                                <img src={it_strategic2}/>
                                <br/><br/>
                                <b>Analysis and Reporting based on QPR FactView</b>
                                <br/><br/>
                                QPR FactView simplifies analysis for everyone. The patented technology allows instant, in-memory manipulation of massive datasets on low-cost hardware, allowing affordable, widespread deployment of sophisticated analytic applications in days.
                                <br/><br/>
                                <img src={it_strategic3}/>
                                <br/><br/>
                                <b>Risk Management and Compliance</b>
                                <br/><br/>
                                The QPR Risk Management and Compliance Solution helps your organization to lift internal control and risk management from being a set of tactical, ad-hoc initiatives to be coming your strategic advantage.
                                <br/><br/>
                                <img src={it_strategic4}/>
                                <br/><br/>
                                <div style={{width:'100%',textAlign:'center'}}>
                                    <img src={it_strategic6} style={{width:'50%'}}/>
                                </div>
                                <br/>
                                <div style={{borderBottom:'3px dashed whitesmoke'}}></div>
                                <br/>
                                <img src={altius} style={{width:'70%'}}/>
                                <br/><br/>
                                Altius is a web-based and task—oriented application that is aimed at automating the process of individual performance management and talent management cycle. It is highly customizable to reflect BSC, MBO, or KPI Scoring framework.
                                <br/><br/>
                                <b>Benefits of Deploying Altius</b>
                                <br/><br/>
                                <b>Paperless work</b><br/>
                                Streamline and increase the efficiency of your performance appraisal process by using Altius web-based performance appraisal form
                                <br/><br/>
                                <b>Time Saving</b><br/>
                                Altius provides your appraiser with easy to use forms that include all of the behavior-based competencies and core values assigned to an employee or group of employees
                                <br/><br/>
                                <b>Faster Workflow</b><br/>
                                Setting individual performance scorecard and employee performance appraisal processes is fast and easy
                                <br/><br/>
                                <b>Fully Customized</b><br/>
                                Individual metrics, competencies, grades and periods can be easily configured
                                <br/><br/>
                                <b>Online Access</b><br/>
                                All employee will be able to monitor their own performance online, enabling them to review and learn how to improve their performance.
                                <br/><br/>
                                <b>Minimum IT Administration resulting in low total cost of ownership</b>
                                <br/><br/>
                                <img src={it_strategic5} />
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
